const ADS_CONVERSION_SEND_TO = 'AW-17126336271/rhfoCOe-m88aEI_OvOY_';
const STORAGE_PREFIX = 'edt_ads_booking_conversion:';

/**
 * Fire Google Ads booking conversion once per successful booking reference.
 * Safe on refresh / remount: sessionStorage blocks duplicate sends for the same ref.
 */
export const trackSuccessfulBookingConversion = (referenceId) => {
  if (typeof window === 'undefined') return false;
  const ref = String(referenceId || '').trim();
  if (!ref) return false;

  const storageKey = `${STORAGE_PREFIX}${ref}`;
  try {
    if (window.sessionStorage.getItem(storageKey)) return false;
  } catch {
    // sessionStorage may be blocked; continue with in-memory guard below
  }

  if (window.__edtAdsConversionFiredRefs?.has(ref)) return false;
  window.__edtAdsConversionFiredRefs = window.__edtAdsConversionFiredRefs || new Set();
  window.__edtAdsConversionFiredRefs.add(ref);

  if (typeof window.gtag !== 'function') return false;

  window.gtag('event', 'conversion', { send_to: ADS_CONVERSION_SEND_TO });

  try {
    window.sessionStorage.setItem(storageKey, '1');
  } catch {
    // ignore quota / privacy mode failures; in-memory set still prevents remount dupes
  }

  return true;
};
